// @flow

import React from "react";
import SearchContext from "../searchContext";
import ReactPaginate from "react-paginate";

const PaginationContainer = () => {
  return (
    <SearchContext.Consumer>
      {({ setFilters, batching, translations }) => {
        const { numpages, pagesize, current_page } = batching;

        const handlePageChange = (data) => {
          setFilters({ b_start: data.selected * pagesize });
        };

        if (numpages && numpages > 1) {
          return (
            <div className="navigation">
              <ReactPaginate
                previousLabel={
                  translations ? translations.previous_label : "Precedente"
                }
                nextLabel={
                  translations ? translations.next_label : "Successivo"
                }
                breakLabel={"..."}
                breakClassName="page-item"
                breakLinkClassName="page-link"
                pageCount={numpages}
                forcePage={current_page - 1}
                onPageChange={handlePageChange}
                containerClassName="pagination my-3"
                subContainerClassName="pages pagination"
                activeClassName="active"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
              />
            </div>
          );
        } else {
          return "";
        }
      }}
    </SearchContext.Consumer>
  );
};

export default PaginationContainer;
